module.exports = __webpack_public_path__ + "img/icons8-uncheck-all.1d42cebf.svg";